<template>
  <el-table-column
    :label="label"
    :prop="prop"
    class-name="action-type-name"
    :sortable="sortable"
  >
    <template slot-scope="scope">
      <el-tag
        :type= actionTypeColor(scope.row.action_type_name)
        disable-transitions>
        {{scope.row.action_type_name}}
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '着離陸・入出庫区分'
    },
    prop: {
      type: String,
      default: 'action_type_name'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    actionTypeColor (actionTypeName) {
      if (actionTypeName === '着陸') {
        return 'danger'
      }
      if (actionTypeName === '入庫') {
        return 'warning'
      }
      if (actionTypeName === '出庫') {
        return 'success'
      }
      if (actionTypeName === '離陸') {
        return ''
      }
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.action-type-name {
      width: 13em;
    }
  }
  .el-tag {
    width: 5.5em;
    text-align: center
  }
}
</style>
